"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MockImageService = /** @class */ (function () {
    function MockImageService() {
        this._images = [];
    }
    MockImageService.prototype.getImageUrl = function (request) {
        return "/mock/image/" + request.id + "/";
    };
    MockImageService.prototype.getImages = function (request) {
        return Promise.resolve(this._images.map(function (img) { return Object.assign({}, img); }));
    };
    MockImageService.prototype.saveImage = function (request) {
        var idx = this._images.findIndex(function (img) { return img.id === request.id; });
        var savedImage;
        if (idx >= 0) {
            savedImage = Object.assign({}, this._images[idx], request);
            this._images[idx] = savedImage;
        }
        else {
            savedImage = Object.assign({}, request);
            this._images.push(savedImage);
        }
        return Object.assign({}, savedImage);
    };
    MockImageService.prototype.deleteImage = function (request) {
        var idx = this._images.findIndex(function (img) { return img.id === request.id; });
        if (idx >= 0) {
            this._images.splice(idx, 1);
        }
        return Promise.resolve();
    };
    return MockImageService;
}());
exports.MockImageService = MockImageService;
